<script setup lang="ts">
import { computed, inject } from 'vue'
import { customElementPropsKey } from '@/types/customElementProps.types'
import Page404 from '@/views/404View.vue'
import routeDefinitions from '.'

const templateProps = inject(customElementPropsKey)

const templateForCurrentView = computed(() => {
  if (templateProps?.template) {
    return routeDefinitions[templateProps?.template] ?? Page404
  } else {
    return Page404
  }
})
</script>

<template>
  <component :is="templateForCurrentView"></component>
</template>
